import ModalStyle from "./style";

export default function ConnectWalletModal({
  setConnectWalletModal,
  connectWalletWalletConnect,
  connectWalletConnect,
}) {
  return (
    <ModalStyle
      className="modal m-0 fade show d-block"
      id="TwoFA"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      style={{
        background: "rgb(0 0 0 / 50%)",
        transition: "all 0.3s",
      }}
    >
      <div 
        onClick={() => setConnectWalletModal(false)}
        style={{
          position: "fixed",
          inset: "0px",
          zIndex: -1,
        }}
      />
      <div
        className="modal-dialog modal-dialog-centered qr-code-modal wizared-2fa add-address-modal modal-lg"
        role="document"
      >
        <div className="modal-content tx-14">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Connect Using ..
            </h5>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              style={{
                background: "transparent",
                border: "none",
                padding: 0,
                fontSize: "2rem",
                width: "36px",
              }}
              onClick={() => setConnectWalletModal(false)}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="connect-wallet-modal-body">
            <button className="metamask" onClick={connectWalletWalletConnect}>
              <img src="/img/metamask.webp" alt="commission-rate" />
              <span>MetaMask</span>
            </button>
            <button className="wallet-connect" onClick={connectWalletConnect}>
              <img src="/img/walletconnect.png" alt="commission-rate" />
              <span>WalletConnect</span>
            </button>
          </div>
        </div>
      </div>
    </ModalStyle>
  );
}
